import React from 'react';

import { AvatarGroup as ChakraAvatarGroup } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { AVATAR_SIZES } from 'uiToolkitV1/Avatar/Avatar';

const StyledAvatarGroup = styled(ChakraAvatarGroup)`
  & .chakra-avatar {
    border: 0;
  }
  & .chakra-avatar__excess {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text.g1};
    background: transparent;
  }
`;

const AvatarGroup = ({ size = AVATAR_SIZES[2], max = 3, children, ...props }) => {
  if (!AVATAR_SIZES.includes(size)) {
    console.error(`Invalid avatar size using ${AVATAR_SIZES[2]} as default.
    Please provide any of ${AVATAR_SIZES} or add the new size and then use`);
    size = AVATAR_SIZES[2];
  }
  return (
    <StyledAvatarGroup size={size} max={max} spacing="1px" {...props}>
      {children}
    </StyledAvatarGroup>
  );
};

export { AvatarGroup };
